/**
 * Общий layout для страницы работы с задачей (решение в одиночку или в сессии).
 * Слева — условие и метаданные, справа — редактор и опциональная боковая панель.
 */
export default function TaskWorkLayout({
  header,
  statement,
  hintsSection,
  editorSlot,
  sidebarSlot,
  className = '',
}) {
  return (
    <div className={`task-work-layout ${className}`}>
      <div className="task-work-main">
        <div className="task-work-statement">
          {header}
          {statement}
          {hintsSection}
          {sidebarSlot}
        </div>
        <div className="task-work-editor">
          {editorSlot}
        </div>
      </div>
    </div>
  );
}
